import { gql } from '@apollo/client/core'
import { ScreeningRule } from '../../../model/screeningRules'
import SCREENING_RULE from '../fragments/screeningRule'

export interface ScreeningRulesData {
  // Nullable to match the schema: draftAudienceV2 returns null for a market with no audience saved yet.
  draftAudience?: {
    surveyId: string
    screeningRules: ScreeningRule[]
  } | null
}

/**
 * Rules are read through their own query rather than by extending the shared DraftAudience fragment.
 * That fragment backs the whole audience page, so adding a field to it would break every consumer against
 * any environment whose schema predates the field. This query is only issued by the rules panel, which is
 * behind the ScreeningRules flag.
 */
export const GET_SCREENING_RULES = gql`
  query screeningRulesV2($projectId: ID!, $surveyId: ID!, $waveId: ID) {
    draftAudience: draftAudienceV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      surveyId
      screeningRules {
        ...ScreeningRule
      }
    }
  }
  ${SCREENING_RULE}
`
